const MenuOverlay = ({ nav, closeModal }) => (
  <aside
    role="button"
    tabIndex={0}
    onClick={closeModal}
    onKeyPress={closeModal}
    className="flex flex-column h-100"
  >
    <span className="sr-only">Click anywhere on the menu to return to the main page.</span>
    <CloseButton closeModal={closeModal} />
    <Links nav={nav} />
    <Logo />
  </aside>
)

export default MenuOverlay

/*
 *
 * General
 * 
 */

import React from 'react'
import FaClose from 'react-icons/lib/fa/close'
import shortid from 'shortid'

import ScrollTo from '../components/ScrollTo'

/*
 *
 * Close Button
 * 
 */

const CloseButton = ({ closeModal }) => (
  <button type="button" onClick={closeModal} className="absolute right-0 pa3">
    <span className="sr-only">Close menu</span>
    <FaClose className="white animate hover:dark-pink" style={{ fontSize: `1.75rem` }} />
  </button>
)

/*
 *
 * Links
 * 
 */

import BuyTickets from '../components/BuyTickets'

const Links = ({ nav }) => (
  <nav
    aria-label="Main navigation"
    className="flex justify-center items-center overflow-scroll scrolling-touch container w-100 h-100 white"
  >
    <ul className="mt5 tc josefin-sans f4 fw7 i ttu">
      {nav.map(item => {
        return (
          <li key={shortid.generate()}>
            {item.text === `Buy Tickets` ? (
              <BuyTickets className="db pv3 tc animate hover:dark-pink" />
            ) : item.text === `Our Story` ? (
              // Offset the "Our Story" link target because the section has no top padding
              <ScrollTo
                href={item.link}
                offset={128}
                className="dib pv3 animate hover:dark-pink"
              >
                {item.text}
              </ScrollTo>
            ) : (
              <ScrollTo href={item.link} className="dib pv3 animate hover:dark-pink">
                {item.text}
              </ScrollTo>
            )}
          </li>
        )
      })}
    </ul>
  </nav>
)

/*
 *
 * Logo
 * 
 */

import pinkLogo from '../svgs/logo-pink.svg'

const Logo = () => (
  <div className="bg-white pa3">
    <ScrollTo href="#top">
      <figure className="ml-auto mr-auto" style={{ maxWidth: `11rem` }}>
        <img
          src={pinkLogo}
          alt="Pink logo showing a pomegranate behind the words 'Pomegranate Opera'."
          style={{ backgroundColor: `transparent` }}
        />
      </figure>
    </ScrollTo>
  </div>
)



// WEBPACK FOOTER //
// ./src/components/MenuOverlay.js